import { useTranslation } from "react-i18next"

export const useErrorTranslation = () => {
    return useTranslation('errors')
}
